var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 17V12.4076M27.4072 9.38667C27.1343 9.40051 26.8596 9.40751 26.5833 9.40751C22.4854 9.40751 19.414 6.5336 16.5832 4C13.7526 6.5335 10.6812 9.40735 6.58333 9.40735C6.30703 9.40735 6.03237 9.40035 5.75951 9.38651C5.42694 10.6713 5.25 12.0188 5.25 13.4076C5.25 20.8629 9.68243 25.794 16.5833 27.5702C23.4842 25.794 27.9167 20.8629 27.9167 13.4076C27.9167 12.0188 27.7397 10.6714 27.4072 9.38667Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.25,
    cy: 21,
    r: 1,
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.6bf451a637241e33886f22d1f21766d5.svg";
export { ForwardRef as ReactComponent };